import { useState, useRef, useCallback } from "react";
import { postChatMessage, fetchChatLog } from "../api/api";

export function useChat(currentAssistant, userId) {
  const [chatLog, setChatLog] = useState([]);
  const [currentThread, setCurrentThread] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const chatLogRef = useRef(null);

  const append = useCallback((msg) => setChatLog((p) => [...p, msg]), []);

  const clear = useCallback(() => {
    setChatLog([]);
    setCurrentThread(null);
  }, []);

  const selectThread = useCallback(async (thread) => {
    setCurrentThread(thread);
    try {
      const { assistantId, messages } = await fetchChatLog(thread.id);
      setChatLog(messages.slice(-10));
      return assistantId;
    } catch (err) {
      console.error("fetchChatLog:", err);
      return null;
    }
  }, []);

  const send = useCallback(
    async (text) => {
      if (!text.trim()) return;
      append({ user: "you", message: text });
      setIsLoading(true);
      try {
        const resp = await postChatMessage(text, currentAssistant, userId, currentThread);
        append({ user: "assistant", message: resp.message });
        if (resp.thread && (!currentThread || resp.thread.id !== currentThread.id)) {
          setCurrentThread(resp.thread);
        }
      } catch (err) {
        console.error("postChatMessage:", err);
        append({ user: "assistant", message: "Failed to fetch response." });
      } finally {
        setIsLoading(false);
      }
    },
    [append, currentAssistant, currentThread, userId]
  );

  return {
    chatLog,
    chatLogRef,
    currentThread,
    isLoading,
    send,
    selectThread,
    clear,
    setCurrentThread,
  };
}
